// extracted by mini-css-extract-plugin
module.exports = {"top":"WeekCard_top__2u6gt","title":"WeekCard_title__2Ciz5","dateSpan":"WeekCard_dateSpan__2Br8b","bottom":"WeekCard_bottom__1ZmmH","dates":"WeekCard_dates__3gcxf"};